import __cloneDeep from 'lodash/cloneDeep';

// Modules getters
export const getForm = state => __cloneDeep(state.form);

export default {
  getForm
};



// WEBPACK FOOTER //
// ./src/store/modules/customer/getters.js